import React, { useEffect } from "react";
import DatePicker from "react-datepicker";

interface DateRangeSelectProps {
  label?: string;
  startDate: Date | null;
  endDate: Date | null;
  onStartDateChange?: (date: Date | null) => void;
  onEndDateChange?: (date: Date | null) => void;
  onDatesChange?: (date: [Date | null, Date | null]) => void;
}

const DateRangeSelect = (props: DateRangeSelectProps) => {
  const [startDate, setStartDate] = React.useState(props.startDate);
  const [endDate, setEndDate] = React.useState(props.endDate);
  const [dates, setDates] = React.useState({
    startDate: props.startDate,
    endDate: props.endDate,
  });

  const handleStartDateChange = (date: Date | null) => {
    setStartDate(date);
    setDates((prev) => ({ ...prev, startDate: date }));
    if (props.onStartDateChange) {
      props.onStartDateChange(date);
    }
  };

  const handleEndDateChange = (date: Date | null) => {
    setEndDate(date);
    setDates((prev) => ({ ...prev, endDate: date }));
    if (props.onEndDateChange) {
      props.onEndDateChange(date);
    }
  };

  useEffect(() => {
    props.onDatesChange && props.onDatesChange([startDate, endDate]);
  }, [startDate, endDate]);

  return (
    <div>
      <label className="control-label" style={{ marginBottom: "5px" }}>
        {props.label ?? "Select Date Range"}
      </label>
      <div style={{ display: "flex", gap: "6px", alignItems: "center" }}>
        <DatePicker
          className="form-control"
          selected={startDate}
          onChange={(date) => handleStartDateChange(date)}
          selectsStart
          startDate={startDate}
          endDate={endDate}
          dateFormat="dd/MM/yyyy"
        />
        <span>-</span>
        <DatePicker
          className="form-control"
          selected={endDate}
          onChange={(date) => handleEndDateChange(date)}
          selectsEnd
          startDate={startDate}
          endDate={endDate}
          minDate={startDate}
          dateFormat="dd/MM/yyyy"
        />
      </div>
    </div>
  );
};

export default DateRangeSelect;
